import { DistributionRequestListModule } from '../DistributionRequestListModule/DistributionRequestListModule';
import {
  IntermediaryInformationCardModule,
  type IntermediaryInformationCardModuleField,
} from '../IntermediaryInformationCardModule/IntermediaryInformationCardModule';
import { ResendPartnershipDocumentModule } from '../ResendPartnershipDocumentModule/ResendPartnershipDocumentModule';

type IntermediaryInformationCard = {
  titleKey: string;
  fields: IntermediaryInformationCardModuleField[];
};

type IntermediaryDetailsModuleProps = {
  /**
   * Information cards rendered under the distribution requests, in order.
   */
  informationCards: ReadonlyArray<IntermediaryInformationCard>;
};

export function IntermediaryDetailsModule({ informationCards }: IntermediaryDetailsModuleProps) {
  return (
    <>
      <ResendPartnershipDocumentModule />

      <DistributionRequestListModule />

      {informationCards.map(({ titleKey, fields }) => (
        <IntermediaryInformationCardModule key={titleKey} titleKey={titleKey} fields={fields} />
      ))}
    </>
  );
}
